import * as Styled from './OxExperienceGrid.styled';

import React from 'react';
import { OxTextHeading } from 'src/components/OxTextHeading';
import { OxTextParagraph } from 'src/components/OxTextParagraph';

type TProps = {
    items: {
        title: string;
        description: string;
        image: any;
    }[];
};

export const OxExperienceGrid = ({ items = [] }: TProps): JSX.Element => {
    const hasImageData = (image: TProps['items'][number]['image']): boolean =>
        !!(image as { asset?: { gatsbyImageData?: unknown } })?.asset?.gatsbyImageData;

    const renderFormattedText = (text: string): React.ReactNode => {
        if (!text) return null;

        const parseBold = (segment: string, segmentIndex: number): React.ReactNode => {
            const parts = segment.split(/(\*\*[^*]+\*\*)/g);
            return parts.map((part, partIndex) => {
                if (part.startsWith('**') && part.endsWith('**')) {
                    return <strong key={`${segmentIndex}-${partIndex}`}>{part.slice(2, -2)}</strong>;
                }
                return part;
            });
        };

        return text.split('\n').map((segment, index, array) => (
            <React.Fragment key={index}>
                {parseBold(segment, index)}
                {index < array.length - 1 && <br />}
            </React.Fragment>
        ));
    };

    return (
        <Styled.List as="ul">
            {items.map((item, index) => (
                <Styled.Item key={index}>
                    <Styled.Text $hasImage={hasImageData(item.image)}>
                        <OxTextHeading>{item.title}</OxTextHeading>
                        <OxTextParagraph>{renderFormattedText(item.description)}</OxTextParagraph>
                    </Styled.Text>
                    {item.image && <Styled.Image fluidImages={[item.image]} />}
                </Styled.Item>
            ))}
        </Styled.List>
    );
};
